module.exports = __webpack_public_path__ + "static/media/rewind-forward-2.25d52a6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/Player/rewind-forward-2.svg
// module id = 7413
// module chunks = 0